<template>
  <ResizablePage>
    <template v-slot:content="conentProps">
      <v-container fluid v-bind:style="{ height: conentProps.tableHeight + 'px' }" class="overflow-y-auto" fill-height>
        <v-layout justify-center>
          <v-row style="max-width: 900px">
            <validation-observer style="width: 100%"
                                 class="px-5"
                                 ref="form_validation"
            >
              <v-form
                @submit.prevent="submit"
                :readonly="!editable">

                <v-expansion-panels multiple flat hover v-model="panels">
                  <v-expansion-panel>
                    <v-expansion-panel-header>{{ $t("view.groupset.group.base") }}</v-expansion-panel-header>
                    <v-expansion-panel-content>

                      <v-row>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="view.groupset.name"
                            rules="required|max:100"
                          >
                            <v-text-field
                              v-model="name"
                              :counter="100"
                              :error-messages="errors"
                              :label="$t('view.groupset.name')"
                              required
                            ></v-text-field>
                          </validation-provider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="view.groupset.note"
                            rules="max:150"
                          >
                            <v-text-field
                              v-model="note"
                              :counter="150"
                              :error-messages="errors"
                              :label="$t('view.groupset.note')"
                              required
                            ></v-text-field>
                          </validation-provider>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel>
                    <v-expansion-panel-header>{{ $t("view.groupset.group.permission") }}</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col>
                          <ItemsSelection
                            v-model="permissions"
                            :items="allPersons"
                            :mapper="personMapper" />
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel>
                    <v-expansion-panel-header>{{ $t("view.groupset.group.vehicles") }}</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col>
                          <ItemsSelection
                            v-model="vehicles"
                            :items="allVehicles"
                            :mapper="vehicleMapper" />
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>


                  <v-expansion-panel>
                    <v-expansion-panel-header>{{ $t("view.groupset.group.persons") }}</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col>
                          <ItemsSelection
                            v-model="persons"
                            :items="allPersons"
                            :mapper="personMapper" />
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-form>
            </validation-observer>
          </v-row>
        </v-layout>

        <v-snackbar
          v-model="showError"
          bottom
          light
          timeout="-1"
          color="red lighten-4"
        >
          {{ errorMessage }}

          <template v-slot:action="{ attrs }">
            <v-btn
              color="indigo"
              text
              v-bind="attrs"
              @click="showError = false"
            >
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </v-container>
    </template>
  </ResizablePage>
</template>

<script>
import utils from "@/utils";
import ResizablePage from "@/components/ResizablePage";
import ItemsSelection from "@/components/ItemsSelection";

export default {
  name: "GroupSetView",
  components: { ItemsSelection, ResizablePage },
  data() {
    return {
      editable: this.canWrite("groupset"),
      canLeave: !this.canWrite("groupset"),
      panels: [0],

      name: null,
      note: null,

      showError: false,
      errorMessage: null,

      record: null,

      permissions: [],
      persons: [],
      vehicles: [],

      allPersons: [],
      allVehicles: []
    }
      ;
  },

  methods: {
    async store() {
      if (await this.$refs.form_validation.validate()) {

        let object = {
          name: this.name,
          note: this.note,

          permissions: this.permissions,
          persons: this.persons,
          vehicles: this.vehicles
        };

        let params = {
          module: "groupset",
          object: object
        };

        if (!utils.isObjectEmpty(this.$store.state.data.record)) {
          params.id = this.record.groupSetId;
          object.groupSetId = this.record.groupSetId;
          object.lastChange = this.record.lastChange;
        }

        let response = await this.$store.dispatch("data/storeRecord", params);

        if (response.error) {
          this.showError = true;
          this.errorMessage = response.message;
        } else {
          this.canLeave = true;
          this.$router.close({ name: "data/groupsets" });
        }
      }
    },

    async remove() {
      let params = {
        module: "groupset",
        id: this.record.groupSetId
      };

      let response = await this.$store.dispatch("data/deleteRecord", params);

      if (response.error) {
        this.showError = true;
        this.errorMessage = response.message;
      } else {
        this.canLeave = true;
        this.$router.close({ name: "data/groupsets" });
      }
    },

    cancel() {
      this.canLeave = true;
      this.$router.close({ name: "data/groupsets" });
    },

    personMapper(item) {
      return {
        id: item.personId,
        name: item.firstName + " " + item.lastName,
        note: utils.personRoles(item, true).map((item) => this.$t("roles." + item)).join(", "),
        obj: item
      };
    },

    vehicleMapper(item) {
      return {
        id: item.vehicleId,
        name: item.numericPlate,
        note: item.name + " ⦁ " + this.$t("enum.vehicle_type." + item.typeCode),
        obj: item
      };
    }
  },

  watch: {
    "$store.state.data.record": function() {
      if (this.$store.state.data.module === "groupset" && this.$store.state.data.record !== null) {
        let record = this.$store.state.data.record;

        if (record.groupSetId === undefined) {
          this.name = null;
          this.note = null;

          this.permissions = [];
          this.persons = [];
          this.vehicles = [];
        } else {
          this.name = record.name;
          this.note = record.note;

          this.permissions = record.permissions;
          this.persons = record.persons;
          this.vehicles = record.vehicles;
        }

        this.record = record;
      }
    },

    "$store.state.data.activeEvent": function() {
      const e = this.$store.state.data.activeEvent;
      if (e != null && e.target === "view") {

        try {
          if (e.click !== undefined) {
            switch (e.click) {
              case "store":
                this.store();
                break;
              case "cancel":
                this.cancel();
                break;
              case "delete":
                this.remove();
                break;
            }
          }
        } finally {
          this.$store.dispatch("data/processEvents");
        }
      }
    }
  },

  mounted() {
    this.$store.dispatch("data/resetEvents");

    Promise.all([this.$store.dispatch("data/fetchVehicles", false), this.$store.dispatch("data/fetchPersons", false)])
      .then(result => {
        this.allVehicles = result[0].data;
        this.allPersons = result[1].data;
      });

    if (this.$route.params.id === "new")
      this.$store.dispatch("data/fetchRecord", { module: "groupset" });
    else
      this.$store.dispatch("data/fetchRecord", { module: "groupset", id: this.$route.params.id });
  },

  async beforeRouteLeave(to, from, next) {
    if (this.canLeave)
      next();
    else {
      const answer = window.confirm(this.$t("view.leave_msg"));
      if (answer) {
        next();
      } else {
        next(false);
      }
    }
  }
};
</script>

<style scoped>

</style>